import {
  type SettingsPropsParametricSelector,
  TargetSelector,
  combinedSettingsSelector,
  createShallowEqualSelector
} from "@client/selectors";
import React from "react";

export const makeStyleSelector = (): SettingsPropsParametricSelector => {
  const settingsSelector = combinedSettingsSelector<{ pushPosition: string; width: string }>(TargetSelector.Entity, [
    "pushPosition",
    { name: "outerWidth", prop: "width" }
  ]);

  return createShallowEqualSelector(
    [settingsSelector],
    (settings): React.CSSProperties => ({
      position: "sticky",
      bottom: settings.pushPosition === "bottom" ? 0 : undefined,
      top: settings.pushPosition === "top" ? 0 : undefined,
      maxWidth: "100%"
    })
  );
};
